import React, { useState } from 'react';

interface CustomCurrencyModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSave: (code: string) => void;
}

export const CustomCurrencyModal: React.FC<CustomCurrencyModalProps> = ({ isOpen, onClose, onSave }) => {
  const [code, setCode] = useState('');

  if (!isOpen) return null;

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (code.trim()) {
      onSave(code.trim().toUpperCase());
      setCode('');
      onClose();
    }
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center z-50 pointer-events-none">
      <div className="bg-white p-6 rounded-lg shadow-xl w-full max-w-xs border border-gray-300 pointer-events-auto">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-xl font-bold text-gray-800">Custom Currency</h2>
          <button type="button" onClick={onClose} className="text-gray-400 hover:text-gray-600">✕</button>
        </div>
        
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Currency Code</label>
            <input
              type="text"
              placeholder="e.g., AUD, INR, MXN"
              maxLength={3}
              required
              autoFocus
              className="w-full p-2 border border-gray-300 rounded focus:ring-2 focus:ring-green-500 outline-none uppercase"
              value={code}
              onChange={(e) => setCode(e.target.value)}
            />
            <p className="text-xs text-gray-500 mt-1">Enter a standard 3-letter currency code.</p>
          </div>
          
          <div className="flex justify-end space-x-3 mt-6 pt-2">
            <button type="button" onClick={onClose} className="px-4 py-2 text-gray-600 hover:bg-gray-100 rounded font-medium transition text-sm">
              Cancel
            </button>
            <button type="submit" className="px-4 py-2 bg-blue-50 text-blue-700 border border-blue-200 rounded hover:bg-blue-100 font-medium shadow-sm transition text-sm">
              Apply
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};